import React, { Component } from 'react';
import { Redirect } from 'react-router-dom';
import { connect } from 'react-redux';
import { withRouter } from "react-router";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { bindActionCreators } from 'redux';

import * as actions from '../../actions/ordersAction';
import * as symbols from '../../operations/symbols';
import { getBase64 } from '../../operations/operations';


class PictureModeModal extends Component {

  constructor(props) {
    super(props);

    this.state = {
      imagesUploaded: []
    }
  }

  handleImageInputClick(type) {
    document.getElementById(type).click((e) => {})
  }

  async handleImagesStore(files) {
    const imgResult = [];
    for (let i = 0; i < files.length; i++) {
      await getBase64(files[i])
        .then((result) => {
          imgResult.push(result)

        })
        .catch((err) => {})
    }
    return imgResult
  }

  handleSelectedImage(e, type) {
    let files = e.target.files;
    this.setState({ imagesUploaded: files }, () => {
      if (this.props.hasSameRoute) {
        this.props.closePictureModeModal();
      }
      this.props.actions.setOrderDetailImages(this.props.id, files, type);
      document.getElementById('takePicture').value = '';
    })
  }

  handleSelectedDefaultImage(e) {
    let files = e.target.files;
    this.setState({ imagesUploaded: files }, () => {
      this.props.setImages(files);
      document.getElementById('takePicture').value = '';
    })
  }

  componentDidMount() {
    this.props.actions.resetOrderDetailImages();
  }

  uploadedImagesRedirect() {
    return (
      <React.Fragment>
       {
          !this.props.redirectedURL ? 
          <Redirect to={{
              pathname: `/order/${this.props.id}`
          }}/> :
          <Redirect to={{
              pathname: `${this.props.redirectedURL}`,
              state: {id: `${this.props.id}`, images: `${this.props.images}`}
          }}/>
       }
      </React.Fragment>
    )
  }

  reasonImagesRedirect() {
    return (
      <React.Fragment>
        {
          !this.props.redirectedURL ? 
          <Redirect to={{
             pathname: `/order/${this.props.id}`
          }}/> :
          <Redirect to={{
             pathname: `${this.props.redirectedURL}`
          }}/>
        }
      </React.Fragment>
    )
  }

  invoiceImagesRedirect() {
    if (!this.props.redirectedURL) {
      this.props.history.push({
        pathname: `/order/${this.props.id}`
      })
    } else {
      this.props.history.push({
        pathname: `${this.props.redirectedURL}`,
        state: {
          id: this.props.id,
          orderNumber: this.props.orderNumber,
          images: this.props.images,
        }
      })
    }
  }

  storeImagesRedirect() {
    if (!this.props.redirectedURL) {
      this.props.history.push({
        pathname: `/order/${this.props.id}`
      })
    } else {
      this.props.history.push({
        pathname: `${this.props.redirectedURL}`,
        state: {
          id: this.props.id,
          orderNumber: this.props.orderNumber,
          invoiceImages: this.props.invoiceImages,
          storeImages: this.props.images
        }
      })
    }
  }

  componentDidUpdate(prevProps) {

    if (prevProps.isOpen != this.props.isOpen && this.props.hasNotWrapper
    ) {
      document.getElementById('takePicture') && this.handleImageInputClick('takePicture');
    }

    
  }

  render() {
    const { isOpen, status, hasNotWrapper } = this.props;
    const { imagesUploaded } = this.state;
    if (isOpen) {
      if (hasNotWrapper) {
        return (
          <React.Fragment>
            { 
              !this.props.default && 
                 this.props.orders.uploadedImages[this.props.id] && 
                 this.props.orders.uploadedImages[this.props.id].length > 0 && 
                 this.uploadedImagesRedirect()              
             }
             { 
               !this.props.default && 
                  (this.props.orders.reasonImages[this.props.id] && 
                  this.props.orders.reasonImages[this.props.id].length > 0) &&
                  this.reasonImagesRedirect()
                 
             }
             { 
               !this.props.default &&
                  (this.props.orders.invoiceImages[this.props.id] && 
                  this.props.orders.invoiceImages[this.props.id].length > 0) &&
                  this.invoiceImagesRedirect()
             }
             {
               !this.props.default &&
                  (this.props.orders.storeImages[this.props.id] &&
                  this.props.orders.storeImages[this.props.id].length > 0) &&
                  this.storeImagesRedirect()
             }
            {
              !this.props.default ?
              <input hidden type="file" accept="image/*" capture="camera" id="takePicture" onChange={(e, type) => this.handleSelectedImage(e, this.props.type)}/> :
              <input hidden type="file" accept="image/*" capture="camera" id="takePicture" onChange={(e) => this.handleSelectedDefaultImage(e)}/>
            }
          </React.Fragment>
        )
      }
      return (
        <div className="modal">
           { 
            !this.props.default && 
               this.props.orders.uploadedImages[this.props.id] && 
               this.props.orders.uploadedImages[this.props.id].length > 0 && 
               this.uploadedImagesRedirect()
           }
           { 
             !this.props.default && 
                (this.props.orders.reasonImages[this.props.id] && 
                this.props.orders.reasonImages[this.props.id].length > 0) &&
                this.reasonImagesRedirect()
               
           }
           { 
             !this.props.default &&
                (this.props.orders.invoiceImages[this.props.id] && 
                this.props.orders.invoiceImages[this.props.id].length > 0) &&
                this.invoiceImagesRedirect()
           }
           {
             !this.props.default &&
                (this.props.orders.storeImages[this.props.id] &&
                this.props.orders.storeImages[this.props.id].length > 0) &&
                this.storeImagesRedirect()
           }
           <div className="modal-overlay modal-picture">
               <div className="modal-title align-left">
                   {this.props.title ? this.props.title : 'Upload Photo'}
                   <FontAwesomeIcon icon="times" className="right" onClick={this.props.closePictureModeModal}/>
               </div>
               <div className="light-line" />
               {
                !this.props.default ?
                <div className="modal-body align-left">  
                    {
                      this.props.modalBody &&  this.props.modalBody()
                    }
                    <input hidden type="file" accept="image/*" capture="camera" id="takePicture" onChange={(e, type) => this.handleSelectedImage(e, this.props.type)}/>
                    <input hidden type="file" accept="image/*" multiple id="selectPicture" onChange={(e, type) => this.handleSelectedImage(e, this.props.type)}/>
                    <div className="btn btn-green btn-expand" onClick={(type) => this.handleImageInputClick('takePicture')}>
                        <FontAwesomeIcon icon="camera" /> &nbsp;Click photo
                    </div> 
                </div> :
                <div className="modal-body align-left">
                    {
                      this.props.modalBody &&  this.props.modalBody()
                    }
                    <input hidden type="file" accept="image/*" capture="camera" id="takePicture" onChange={(e) => this.handleSelectedDefaultImage(e)}/>
                    <input hidden type="file" accept="image/*" multiple id="selectPicture" onChange={(e) => this.handleSelectedDefaultImage(e)}/>
                    <div className="btn btn-green btn-expand" onClick={(type) => this.handleImageInputClick('takePicture')}>
                        <FontAwesomeIcon icon="camera" /> &nbsp;Click photo
                    </div>
                </div>
               }
           </div>
       </div>
      )
    }
    return null

  }
}

export default withRouter(connect(
  state => ({
    errors: state.statuses.orderDetailImages.errors,
    status: state.statuses.orderDetailImages.status,
    orders: state.orders
  }),
  dispatch => ({
    actions: bindActionCreators(actions, dispatch),
  }),
)(PictureModeModal));
